"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseLineModel = void 0;
const product_main_group_enum_1 = require("../products-matrix/product-main-group.enum");
const jf = __importStar(require("joiful"));
const case_line_status_enum_1 = require("./case-line-status.enum");
class CaseLineModel {
}
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "id", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "caseLineNumber", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productImageUrl", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productGroupId", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productGroupName", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productFabricSize", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productNumber", void 0);
__decorate([
    (jf.string().required()),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productMainGroup", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productName", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "returnDate", void 0);
__decorate([
    (jf.string().required().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productId", void 0);
__decorate([
    (jf.string().optional().max(20)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "status", void 0);
__decorate([
    (jf.number().required()),
    __metadata("design:type", Number)
], CaseLineModel.prototype, "quantity", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "distanceRun", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "defectReason", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "comments", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "customerName", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "purchaseDate", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "productCode", void 0);
__decorate([
    (jf.string().max(255)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "factoryCode", void 0);
__decorate([
    (jf.array()),
    __metadata("design:type", Array)
], CaseLineModel.prototype, "images", void 0);
__decorate([
    (jf.string().max(50)),
    __metadata("design:type", String)
], CaseLineModel.prototype, "possibleOriginalOrder", void 0);
exports.CaseLineModel = CaseLineModel;
//# sourceMappingURL=case-line.model.js.map